import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import Swal from 'sweetalert2';
import { ToastrService } from 'ngx-toastr';
import { Router } from '@angular/router';
import { LeadService } from 'src/app/services/lead.service';
import { Select2Data } from 'ng-select2-component';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { RenaultLeadDTO, RenaultLeadMessageDTO, RenaultLeadMessagePostDTO } from 'src/app/models/renault-lead-dto';
import { RenaultUserDTO } from 'src/app/models/renault-user-dto';
import { Helpers } from 'src/app/helpers/helpers';
import { LeadSource, LeadType, Status } from '../../../../helpers/enum';

@Component({
  selector: 'best-practice-modal',
  templateUrl: './lead-message-modal.component.html',
  styleUrls: ['./lead-message-modal.component.css'],
})
export class LeadMessageModalComponent implements OnInit {

  guidModal;
  videoModal;
  leadsStatusData: Select2Data;
  dataformMessage: FormGroup;
  submitted = 0;
  @Input() lead: RenaultLeadDTO;
  @Input() userInfo: RenaultUserDTO;
  @Input() type: number;
  @Input() idMessage: string;
  @Input() idSource: number;
  postMessageModel: RenaultLeadMessagePostDTO = new RenaultLeadMessagePostDTO();
  newStatusLead: number;
  LeadType = LeadType;
  message: RenaultLeadMessageDTO = new RenaultLeadMessageDTO();

  constructor(
    public activeModal: NgbActiveModal,
    private toastr: ToastrService,
    private helper: Helpers,
    private service: LeadService,
  ) { }

  ngOnInit(): void {
    //if(this.source !== 'INTERNET')
    this.loadData();

    this.postMessageModel.IdStatusLead = +this.lead.IdStatus;
    this.newStatusLead = +this.lead.IdStatus;

    this.dataformMessage = new FormGroup({
      IdUser: new FormControl(null),
      Message: new FormControl(null, [Validators.required]),
      RadioResultado: new FormControl('Realizado'),
      RadioSituacion1: new FormControl('Cliente no contesta'),
      RadioSituacion2: new FormControl('Pendiente contactar')
    });
  }

  closeModal() {
    this.activeModal.close(null);
  }

  loadData() {
    this.service.getLeadsStatus(false).subscribe(resp => {
      this.leadsStatusData = resp;
    }, (err) => {
      Swal.fire({
        icon: 'error',
        title: 'Error al recuperar los datos',
        text: 'Ocurrió un error',
        buttonsStyling: false,
        customClass: {
          confirmButton: 'btn btn-outline-secondary'
        },
        confirmButtonText: 'Cerrar'
      });
    });

    if (this.idMessage?.trim() != '') {
      this.service.getMessage(this.idMessage).subscribe(resp => {
        this.message = resp;
        this.dataformMessage.patchValue({ Message: this.message.Message });
        this.newStatusLead = this.message.IdStatusLead;
      }, (err) => {
        Swal.fire({
          icon: 'error',
          title: 'Error al recuperar los datos',
          text: 'Ocurrió un error',
          buttonsStyling: false,
          customClass: {
            confirmButton: 'btn btn-outline-secondary'
          },
          confirmButtonText: 'Cerrar'
        });
      });
    }
  }

  postMessage() {
    this.submitted = 1;

    if (this.dataformMessage.invalid) return;

    this.dataformMessage.controls["IdUser"].setValue(this.userInfo.IdUser);
    this.postMessageModel = this.dataformMessage.value;
    this.postMessageModel.IdLead = this.lead.IdLead;

    if (!this.idMessage)
      this.postMessageModel.IdStatusLead = (this.idSource == LeadSource.Internet || this.idSource == LeadSource.R2) ? this.calcStatus() : this.newStatusLead;
    else {
      this.postMessageModel.IdStatusLead = (this.idSource == LeadSource.Internet || this.idSource == LeadSource.R2) ? this.message.IdStatusLead : this.newStatusLead;
      this.postMessageModel.Result = this.message.Result;
      this.postMessageModel.Situation = this.message.Situation;
    }

    this.postMessageModel.IdMessage = this.idMessage;

    Swal.showLoading();

    this.service.postMessage(this.helper.getFormData(this.postMessageModel)).subscribe(resp => {

      Swal.close();

      if (+this.lead.IdStatus != this.postMessageModel.IdStatusLead)
        this.changeStatus(this.lead.IdLead, this.postMessageModel.IdStatusLead);
      else {
        this.toastr.success("El registro se ha creado correctamente");
        this.activeModal.close(true);
      }


    }, (err) => {
      Swal.fire({
        icon: 'error',
        title: 'Error al crear',
        text: 'Ocurrió un error',
        buttonsStyling: false,
        customClass: {
          confirmButton: 'btn btn-outline-secondary'
        },
        confirmButtonText: 'Cerrar'
      });
    });
  }

  getStatus(event) {
    if (event.value != this.lead.IdStatus) {
      this.newStatusLead = +event.value;
    }
  }

  calcStatus(): number {
    // 4: TRATADO | 5: CERRADO | 12: EN TRATAMIENTO | 13: NUEVO | 25: EN RETRASO
    this.postMessageModel.Result = this.dataformMessage.controls.RadioResultado.value

    if (this.dataformMessage.controls.RadioResultado.value == 'Realizado') {
      this.postMessageModel.Situation = this.dataformMessage.controls.RadioSituacion1.value
      return (this.dataformMessage.controls.RadioSituacion1.value == 'Cliente interesado' || this.dataformMessage.controls.RadioSituacion1.value == 'Cliente no interesado') ? Status.Cerrado : Status.EnTratamiento
    } else {
      this.postMessageModel.Situation = this.dataformMessage.controls.RadioSituacion2.value
      return this.dataformMessage.controls.RadioSituacion2.value == 'Email incorrecto' ? Status.Cerrado : Status.EnTratamiento
    }
  }

  changeStatus(idLead, idStatus) {
    this.service.changeStatus(idLead, idStatus).subscribe(() => {
      this.toastr.success("El registro se ha creado correctamente");
      this.activeModal.close(true);

    }, (err) => {
      Swal.fire({
        icon: 'error',
        title: 'Error al cambiar el estado',
        text: 'Ocurrió un error',
        buttonsStyling: false,
        customClass: {
          confirmButton: 'btn btn-outline-secondary'
        },
        confirmButtonText: 'Cerrar'
      });
    });
  }
}
